import React from 'react';
export const SendIcon = ({ customClass }) => (
  <svg width="20" height="20" viewBox="0 0 19.54 19.54" className={customClass}>
    <path
      d="M3.375,13.845,8.96,15.94l.7,6.975,3.49-4.885,4.885,4.885,4.885-19.54Zm13.852,5.918-3.894-3.922,5.4-7.581-8.516,6.473L6.987,13.568,20.656,6.231Z"
      transform="translate(-3.375 -3.375)"
      fill="currentColor"
    />
  </svg>
);

export const LikeIcon = ({ customClass }) => (
  <svg
    className={customClass ? `${customClass} fs-16` : ' fs-16'}
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 478.174 478.174"
  >
    <g>
      <path
        d="M457.525,153.074c1.9-5.1,3.7-12,4.2-20c0.7-14.1-2.8-33.9-22.7-51.9c1.3-9.2,1.3-23.8-6.8-38.3
                        c-10.7-19.2-31.6-32.2-62.2-38.7c-20.5-4.4-47.4-5.3-80-2.8c-65.7-1.3-129.7,6.8-133.3,7.3l-23.5,2.8c-6.8-4.8-15.1-7.6-24-7.6h-61
                        c-23,0-41.6,18.7-41.6,41.6v162.5c0,23,18.7,41.6,41.6,41.6h61c7.2,0,13.9-1.8,19.8-5c4.2,9.2,10.4,19.7,19.6,29.4
                        c0.5,0.5,1,1,1.6,1.4c31.4,24.1,68.4,110.9,81.5,146.3c-1.3,11-2.6,34.8,8.4,47.7c4.9,5.7,11.7,8.8,19.3,8.8
                        c7.7,0,34.3-1.8,50.9-24.7c15.7-21.8,16.6-54.4,2.6-97c-11.8-35.8-12.9-51.7-12.5-58.1c5.4,1.2,10.7,2.3,15.8,3.2h0.1
                        c0.9,0.2,22.9,5.1,49.2,6.3c37.4,1.8,64.5-4.7,80.3-19.2c21.8-19.9,19.2-45.3,12.7-61.5c5.6-7.3,12.4-19.2,13-34.4
                        C471.925,178.974,467.325,165.674,457.525,153.074z M109.225,222.674h-61c-8.1,0-14.6-6.6-14.6-14.6v-162.5
                        c0-8.1,6.6-14.6,14.6-14.6h61c8.1,0,14.6,6.6,14.6,14.6v162.5C123.825,216.174,117.325,222.674,109.225,222.674z M430.925,232.374
                        c0,0.1,3.5,5.6,4.7,13.1c1.5,9.3-1.1,17-8.1,23.4c-19.1,17.4-74.1,13.4-104.8,6.6c-0.4-0.1-0.8-0.2-1.3-0.3
                        c-5.5-1-11.4-2.2-17.4-3.5c-6.4-2.3-15.2-2-21.8,3.9c-13.3,11.8-11.8,38.6,4.9,89.5c11,33.4,11.4,58.6,1.2,72.7
                        c-8.6,11.9-22.8,13.4-28.2,13.5c-2.4-4-3.1-17.7-1.3-29c0.3-2.2,0.1-4.5-0.6-6.7c-1.9-5.1-45.8-125.3-90.7-160.9
                        c-11.7-12.7-16.8-27.6-18.6-34.3c1.2-3.9,1.9-8.1,1.9-12.4v-162.4c0-3-0.3-6-0.9-8.8l10.1-1.2h0.1c0.6-0.1,65.7-8.5,130-7.1
                        c0.4,0,0.9,0,1.4,0c30.3-2.4,54.8-1.7,72.9,2.2c22.4,4.8,37.2,13.2,44,25.1c7.1,12.3,3.2,25,2.9,26.2c-2.1,5.6-0.2,11.7,4.6,15.3
                        c29.6,22.2,16,48.1,14.2,51.3c-3.3,5.2-2.5,11.8,1.8,16.3c8.6,9,12.8,18,12.5,26.8c-0.4,13.1-10.5,22.9-11.2,23.5
                        C428.225,219.474,427.325,226.774,430.925,232.374z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const DislikeIcon = ({ customClass }) => (
  <svg
    className={customClass ? `${customClass} fs-16` : ' fs-16'}
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 478.174 478.174"
  >
    <g>
      <path
        d="M457.525,153.074c1.9-5.1,3.7-12,4.2-20c0.7-14.1-2.8-33.9-22.7-51.9c1.3-9.2,1.3-23.8-6.8-38.3
                        c-10.7-19.2-31.6-32.2-62.2-38.7c-20.5-4.4-47.4-5.3-80-2.8c-65.7-1.3-129.7,6.8-133.3,7.3l-23.5,2.8c-6.8-4.8-15.1-7.6-24-7.6h-61
                        c-23,0-41.6,18.7-41.6,41.6v162.5c0,23,18.7,41.6,41.6,41.6h61c7.2,0,13.9-1.8,19.8-5c4.2,9.2,10.4,19.7,19.6,29.4
                        c0.5,0.5,1,1,1.6,1.4c31.4,24.1,68.4,110.9,81.5,146.3c-1.3,11-2.6,34.8,8.4,47.7c4.9,5.7,11.7,8.8,19.3,8.8
                        c7.7,0,34.3-1.8,50.9-24.7c15.7-21.8,16.6-54.4,2.6-97c-11.8-35.8-12.9-51.7-12.5-58.1c5.4,1.2,10.7,2.3,15.8,3.2h0.1
                        c0.9,0.2,22.9,5.1,49.2,6.3c37.4,1.8,64.5-4.7,80.3-19.2c21.8-19.9,19.2-45.3,12.7-61.5c5.6-7.3,12.4-19.2,13-34.4
                        C471.925,178.974,467.325,165.674,457.525,153.074z M109.225,222.674h-61c-8.1,0-14.6-6.6-14.6-14.6v-162.5
                        c0-8.1,6.6-14.6,14.6-14.6h61c8.1,0,14.6,6.6,14.6,14.6v162.5C123.825,216.174,117.325,222.674,109.225,222.674z M430.925,232.374
                        c0,0.1,3.5,5.6,4.7,13.1c1.5,9.3-1.1,17-8.1,23.4c-19.1,17.4-74.1,13.4-104.8,6.6c-0.4-0.1-0.8-0.2-1.3-0.3
                        c-5.5-1-11.4-2.2-17.4-3.5c-6.4-2.3-15.2-2-21.8,3.9c-13.3,11.8-11.8,38.6,4.9,89.5c11,33.4,11.4,58.6,1.2,72.7
                        c-8.6,11.9-22.8,13.4-28.2,13.5c-2.4-4-3.1-17.7-1.3-29c0.3-2.2,0.1-4.5-0.6-6.7c-1.9-5.1-45.8-125.3-90.7-160.9
                        c-11.7-12.7-16.8-27.6-18.6-34.3c1.2-3.9,1.9-8.1,1.9-12.4v-162.4c0-3-0.3-6-0.9-8.8l10.1-1.2h0.1c0.6-0.1,65.7-8.5,130-7.1
                        c0.4,0,0.9,0,1.4,0c30.3-2.4,54.8-1.7,72.9,2.2c22.4,4.8,37.2,13.2,44,25.1c7.1,12.3,3.2,25,2.9,26.2c-2.1,5.6-0.2,11.7,4.6,15.3
                        c29.6,22.2,16,48.1,14.2,51.3c-3.3,5.2-2.5,11.8,1.8,16.3c8.6,9,12.8,18,12.5,26.8c-0.4,13.1-10.5,22.9-11.2,23.5
                        C428.225,219.474,427.325,226.774,430.925,232.374z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const FemalesIcon = ({ customClass }) => (
  <svg
    fill="currentColor"
    className={customClass ? `${customClass} fs-1` : ' fs-1'}
    viewBox="0 0 64 64"
  >
    <g>
      <g>
        <path
          d="m60 63c-.6 0-1-.4-1-1 0-2.4-1-7-8.1-10.9-1.3-.7-2.9-1.3-4.7-2-4.3-1.6-9.3-3.5-9.3-7.5v-4c0-.6.4-1 1-1s1 .4 1 1v4c0 2.6 4.1 4.2 8 5.7 1.8.7 3.5 1.3 4.9 2.1 8 4.4 9.2 9.8 9.2 12.6 0 .6-.4 1-1 1z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m4 63c-.6 0-1-.4-1-1 0-2.8 1.2-8.3 9.1-12.6 1.4-.8 3.1-1.4 4.9-2.1 3.9-1.5 8-3 8-5.7v-4c0-.6.4-1 1-1s1 .4 1 1v4c0 4-4.9 5.9-9.3 7.5-1.7.7-3.4 1.3-4.7 2-7 3.9-8 8.5-8 10.9 0 .6-.4 1-1 1z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m32 57c-6 0-11.5-3.5-13.9-9-.2-.5 0-1.1.5-1.3s1.1 0 1.3.5c2.1 4.7 6.9 7.8 12.1 7.8 5.2 0 10-3.1 12.1-7.8.2-.5.8-.7 1.3-.5s.7.8.5 1.3c-2.4 5.5-7.9 9-13.9 9z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m32 41c-5.3 0-10.4-5-11.9-11.4-1.4-.5-3.1-2-3.1-5.6 0-.9.1-1.8.4-2.5.3-.9 1.1-1.5 2.1-1.6 2.7-.3 3.5-2.4 4.4-5.5.6-2.2 1.3-4.5 3.6-4.5 1.2 0 2.2.4 2.9.7.5-.4 1.4-.7 2.9-.7 2.3 0 3.9 2.3 5.7 4.8 1.7 2.4 3.5 4.9 5.7 5.2.9.1 1.6.7 2 1.5.2.8.3 1.6.3 2.6 0 3.6-1.8 5.1-3.1 5.6-1.5 6.4-6.6 11.4-11.9 11.4zm-12.3-19c-.2 0-.3.1-.4.3-.2.4-.3 1-.3 1.7 0 3.5 2 3.8 2.1 3.8.4 0 .8.4.9.8 1.2 6.4 6.1 10.4 10 10.4s8.8-4 10-10.4c.1-.4.4-.8.9-.8.2 0 2.1-.4 2.1-3.8 0-.9-.2-1.4-.3-1.7-.1-.2-.2-.3-.4-.3-3.1-.4-5.2-3.4-7.1-6-1.4-1.9-2.8-3.9-4-3.9-1.5 0-1.9.5-1.9.5-.1.2-.3.4-.6.4-.3.1-.6 0-.8-.2 0 0-1-.8-2.4-.8-.7 0-1.1 1.2-1.7 3.1-.8 2.7-1.9 6.5-6.1 6.9z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m48.1 41c-3.6 0-5-.7-5.1-.7-.5-.2-.7-.8-.4-1.3.2-.5.8-.7 1.3-.4s1.2.5 4.2.5c2.9 0 3.9-2.1 3.9-4 0-3-1.5-6.2-2.2-7.7-.6-1.3-.5-2.9-.4-4.5.1-1.5.2-3-.2-4.5-.5-2-1.8-3.5-3-4.8-.6-.6-1.1-1.2-1.5-1.8s-.8-1.4-1.2-2.3c-1.3-3-2.9-6.5-7.5-6.5-3.8 0-5.2 1.6-5.2 1.6-.3.4-1 .5-1.4.1-.4-.3-.5-1-.2-1.4.1 0 1.9-2.3 6.8-2.3 5.9 0 8 4.5 9.4 7.5.4.8.7 1.5 1 1.9.4.5.9 1.1 1.4 1.6 1.3 1.5 2.9 3.2 3.5 5.7.4 1.8.3 3.6.2 5.1s-.2 2.7.2 3.6c.8 1.7 2.3 5.1 2.3 8.5 0 3.1-1.8 6.1-5.9 6.1z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m15.9 41c-4.1 0-5.9-3-5.9-6 0-3.4 1.6-6.9 2.3-8.5.4-.8.3-2.1.2-3.6-.1-1.6-.2-3.3.2-5.1.6-2.6 2.1-4.2 3.5-5.7.5-.6 1-1.1 1.4-1.6.3-.5.7-1.2 1-1.9 1.2-2.7 3-6.6 8.4-6.6 1.7 0 3.4 1 3.5 1.2.5.3.6.9.3 1.4s-.9.6-1.4.3c-.3-.3-1.5-.9-2.4-.9-4.1 0-5.4 2.8-6.6 5.4-.4.8-.7 1.6-1.2 2.2s-1 1.2-1.5 1.8c-1.2 1.4-2.5 2.8-3 4.8-.3 1.5-.3 3.1-.2 4.5.1 1.7.2 3.2-.4 4.5-.6 1.6-2.1 4.8-2.1 7.8 0 1.9 1 4 3.9 4 3.1 0 4.2-.5 4.3-.5.5-.2 1.1 0 1.3.5s0 1.1-.4 1.3c-.2 0-1.6.7-5.2.7z"
          fill="rgb(0,0,0)"
        />
      </g>
    </g>
  </svg>
);

export const MalesIcon = ({ customClass }) => (
  <svg
    fill="currentColor"
    className={customClass ? `${customClass} fs-1` : ' fs-1'}
    id="Image"
    viewBox="0 0 64 64"
  >
    <g>
      <g>
        <path
          d="m32 41c-3.4 0-4.6-.8-5.7-1.6-.3-.2-.5-.4-.8-.5-3-1.8-5.2-4.9-6.2-9.3-1.4-.5-3.3-2-3.3-5.6 0-2.8 1.3-3.7 1.4-3.8.5-.3 1.1-.2 1.4.3s.2 1.1-.3 1.4-.6.5-.6 2.2c0 3.4 2.1 3.8 2.3 3.8.4.1.8.4.9.8.6 2.8 1.9 6.6 5.3 8.6.4.2.7.4 1 .6 1 .7 1.8 1.2 4.5 1.2 2.8 0 3.5-.5 4.5-1.2.3-.2.6-.4 1-.6 3.4-2 4.8-5.7 5.3-8.6.1-.4.5-.8.9-.8.2 0 2.3-.4 2.3-3.8 0-1.7-.6-2.2-.6-2.2-.5-.3-.6-.9-.2-1.4.3-.5 1-.6 1.4-.2.1.1 1.4 1.1 1.4 3.8 0 3.6-1.9 5.1-3.3 5.6-1 4.3-3.1 7.5-6.2 9.3-.3.2-.6.4-.8.5-1 .7-2.2 1.5-5.6 1.5z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m18 22c-.4 0-.7-.2-.9-.6-.2-.5 0-1.1.5-1.3 2.6-1.2 4.6-3.8 6.5-8.5.1-.3.4-.5.7-.6s.7 0 .9.3c2.9 2.7 7 2.1 9.7 1.7.8-.1 1.5-.2 2-.2 4 0 5.6 2.9 6.7 5 .7 1.4 1.2 2.3 1.9 2.3.6 0 1 .4 1 1s-.4 1-1 1c-1.9 0-2.8-1.7-3.7-3.3-1.1-2-2.1-3.9-4.9-3.9-.4 0-1 .1-1.7.2-2.6.4-6.9 1-10.3-1.3-2 4.4-4.2 7-7 8.3-.1-.1-.3-.1-.4-.1z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m62 63c-.6 0-1-.4-1-1 0-5.5 0-9.9-7.8-11.8-6.5-1.5-14.2-4.5-14.2-9.6v-4.1c0-.6.4-1 1-1s1 .4 1 1v4.1c0 2.9 4.6 5.7 12.6 7.7 9.4 2.2 9.4 8.3 9.4 13.6 0 .6-.4 1.1-1 1.1z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m2 62h-1c0-5.4 0-11.5 9.4-13.7 8-1.9 12.6-4.7 12.6-7.7v-4.1c0-.6.4-1 1-1s1 .4 1 1v4.1c0 5.1-7.7 8.1-14.2 9.6-7.8 1.9-7.8 6.3-7.8 11.7z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m32 55c-5.7 0-11.2-2.6-15-7.1-.4-.4-.3-1 .1-1.4s1-.3 1.4.1c3.5 4.1 8.4 6.4 13.5 6.4s10-2.3 13.5-6.4c.4-.4 1-.5 1.4-.1s.5 1 .1 1.4c-3.8 4.5-9.3 7.1-15 7.1z"
          fill="rgb(0,0,0)"
        />
      </g>
      <g>
        <path
          d="m17.7 22.3c-.4 0-.8-.2-.9-.6-.8-2.1-.8-2.8-.8-7.7 0-4.2 2.6-7.6 5.3-8.8 2.1-2.9 5.4-4.2 10.7-4.2 2.6 0 5.1.5 7.2 1.4 3.5 1 6.6.6 6.6.6.5-.1 1 .3 1.1.8 0 .1.5 2.3-.8 4.2 1.3 2.1 1.8 5.1 1.8 7.2 0 1.9 0 4.4-.8 6.5-.2.5-.8.8-1.3.6s-.8-.8-.6-1.3c.7-1.7.7-3.9.7-5.8 0-2-.6-5-1.8-6.6-.3-.4-.3-.9 0-1.3.6-.8.8-1.6.8-2.3-1.3 0-3.7 0-6.3-.7-.1 0-.1 0-.2-.1-1.8-.8-4-1.2-6.4-1.2-5.9 0-7.9 1.7-9.2 3.6-.1.2-.3.3-.5.4-2.1.8-4.3 3.5-4.3 7 0 4.8 0 5.2.7 6.9.2.5-.1 1.1-.6 1.3-.1.1-.3.1-.4.1z"
          fill="rgb(0,0,0)"
        />
      </g>
    </g>
  </svg>
);
